import { AutoCompleteOption } from "./types";

export const orderByQuery = (items: AutoCompleteOption[], query: string) =>
  items.sort((a, b) => {
    const aLabel = a.label?.toLowerCase() || "";
    const bLabel = b.label?.toLowerCase() || "";
    const lowerCaseQuery = query.toLowerCase();

    // Exact matches come first
    const aIsExact = aLabel === lowerCaseQuery;
    const bIsExact = bLabel === lowerCaseQuery;
    if (aIsExact && !bIsExact) {
      return -1;
    }
    if (!aIsExact && bIsExact) {
      return 1;
    }

    // Then items that start with the query
    const aStartsWithQuery = aLabel.startsWith(lowerCaseQuery);
    const bStartsWithQuery = bLabel.startsWith(lowerCaseQuery);
    if (aStartsWithQuery && !bStartsWithQuery) {
      return -1;
    }
    if (!aStartsWithQuery && bStartsWithQuery) {
      return 1;
    }

    // Finally, sort alphabetically
    return aLabel.localeCompare(bLabel);
  });
